export default "__VITE_PUBLIC_ASSET__89baccab__"